import {
  ApplicationRequest as SharedApplicationRequest,
  RequestStatus as SharedRequestStatus,
  REQUEST_STATUSES as SharedRequestStatuses,
} from "shared/dist/types/ApplicationRequest";

export type RequestStatus = SharedRequestStatus;
export const REQUEST_STATUSES = SharedRequestStatuses;

export default interface ApplicationRequest extends SharedApplicationRequest {}
